import React, { FC } from 'react';
import { getLength } from '@collaborator/npm_modules/dist/helpers/string/StringHelper';

type PropsType = {
  isAvailable: boolean,
  value: string | ReadonlyArray<string> | number,
}

const Counter: FC<PropsType> = ({
  isAvailable = true,
  value,
}) => {
  if (!isAvailable) {
    return null;
  }

  return (
    <div className="text-counter text-success">
      {getLength(value as string)}
    </div>
  );
};

export { Counter };
